import { POST, PUT } from "config/constants/adapter_constants";
import { getTenantFromToken } from "config/helpers/common_helper";
import i18n from "multilingual";
import { toast } from "react-toastify";
import { auditPayload } from "./audithelpers";
import HTTPRequest, {
  FHIRDelete,
  FHIRSave,
  FHIRSearch,
  HTTPAidaBaseService,
  HTTPAidaBaseServiceMultipartFormData,
  NokiEndpointService,
  NokiService,
  OrieService,
} from "./http";
import { isEmpty } from "lodash";
import { getHolidayListFromConfig } from "utils/holidayUtils";

export const GET_PATIENT = async (activePersonId) => {
  try {
    let res = await FHIRSearch(`Patient/${activePersonId}`);
    if (res?.data?.total > 0) {
      return res.data.entry[0];
    } else {
      toast.info(i18n.t("common.PATIENT_DATA_NOT_FOUND"));
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const UPDATE_PATIENT = async (payload) => {
  try {
    let response = await FHIRSave(PUT, payload);
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR_UPDATING_PATIENT"));
  }
};

export const GET_LOCATIONS = async (query) => {
  try {
    let filterToRemoveVirtualLocation = `type:not=http://enliv.com/location/type|enliv-internal-virtual-location`;
    let res = await FHIRSearch(`Location?${filterToRemoveVirtualLocation}${query}`);
    if (res?.data?.total > 0) {
      return res;
    } else {
      // toast.info(i18n.t("common.LOCATIONS_NOT_FOUND"));
      console.info("Locations not found");
    }
  } catch (error) {
    debugger
    const issue = error?.response?.data?.issue?.[0];
    const message =
      issue?.diagnostics ||
      "Something went wrong. Please try again.";

    // Show toast
    toast.error(message);
  }
};

export const GET_LOCATION_BY_ID = async (id) => {
  try {
    let res = await FHIRSearch(`Location/${id}`);
    if (res?.data?.total > 0) {
      return res?.data?.entry?.[0];
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_PRACTITIONER = async (payload) => {
  try {
    let res = await FHIRSave(POST, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const SAVE_USER_SETTINGS = async (method, payload) => {
  try {
    let res = await FHIRSave(method, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_USER_SETTINGS = async (personId) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Basic&code=user.preference.ui&subject=Person/${personId}`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const SAVE_TEMPLATE_PREFERENCES = async (method, payload) => {
  try {
    let res = await FHIRSave(method, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const SAVE_DEFAULT_TEMPLATE_PREFERENCES = async (method, payload) => {
  try {
    let res = await FHIRSave(method, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const DELETE_VISIT = async (compositionId) => {
  try {
    let response = await FHIRDelete("Composition", compositionId);
    return response;
  } catch (error) {
    console.log(error.message);
  }
};

export const GET_VISITS_BY_KEYWORD = async ({ patientId, searchKeyword }) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Composition&subject=${patientId}&title:contains=${searchKeyword}&status=preliminary,amended,final`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_ENCOUNTER = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_TASK = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_TASK_BY_ID = async (taskId) => {
  try {
    let res = await FHIRSearch(`Task/${taskId}`);
    if (res?.data?.total > 0) {
      return res.data.entry[0];
    } else {
      toast.info("Task not found");
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const UPDATE_COMPOSITION = async (payload) => {
  try {
    let response = await FHIRSave(PUT, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_OBSERVATION = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_COMPOSITION = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_PATIENT = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const UPDATE_CLINICAL_IMPRESSION = async (payload) => {
  try {
    let response = await FHIRSave(PUT, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_COMPOSITION = async (encounterId, { patientId = "" } = {}) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Composition&encounter=${encounterId}&status=preliminary,amended,final`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_CLINICAL_IMPRESSION = async (
  encounterId,
  { patientId = "" } = {}
) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Observation&encounter=${encounterId}&_sort=date`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_OBSERVATON_BY_ID = async (id) => {
  try {
    let response = await FHIRSearch(`/Observation/${id}`);
    return response?.data?.entry?.[0];
  } catch (err) {
    console.log("e");
  }
};

export const GET_PROMPT_LIST = async () => {
  try {
    const response = await HTTPRequest.get(
      `/ai-copilot/v1/${getTenantFromToken()}/prompt/list`
    );
    return response?.data;
  } catch (error) {
    console.error(error.message);
  }
};

export const GET_ICD_CPT_CODES = async (payload) => {
  try {
    let response = await HTTPAidaBaseService.post(
      `/${getTenantFromToken()}/generate-codes`,
      {
        ...payload,
      }
    );
    return response;
  } catch (error) {
    console.error(error.message);
    return error;
  }
};

export const EXECUTE_PROMPT = async ({
  prompt_code = "",
  language = "English",
  transcript = "",
  previous_soap_note = "",
  patient = {},
  patient_details = {},
  soap_note = "",
  practitioner = {},
  currentDate = "",
  signal,
  requireLanguageAndConversation = true,
  source_language,
  target_language,
}) => {
  let payload = {
    params: {},
  };
  if (requireLanguageAndConversation) {
    payload.params = {
      language: language,
      conversation: transcript,
    };
  }
  if (source_language) {
    payload.params.source_language = source_language;
  }
  if (target_language) {
    payload.params.target_language = target_language;
  }
  if (!isEmpty(patient)) {
    payload.params.patient = { ...patient };
  }
  if (!isEmpty(patient_details)) {
    payload.params.patient_details = { ...patient_details };
  }
  if (!isEmpty(practitioner)) {
    payload.params["referring_doctor"] = { ...practitioner };
  }
  if (!isEmpty(currentDate) && currentDate.length > 0) {
    payload.params["current_date"] = currentDate;
  }

  if (previous_soap_note) {
    payload.params.previous_soap_note = previous_soap_note;
  }
  if (soap_note) {
    payload.params.soap_note = soap_note;
  }
  try {
    const response = await HTTPAidaBaseService.post(
      `/${getTenantFromToken()}/submit/${prompt_code}`,
      payload,
      { signal: signal }
    );

    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    console.error(error.message);
    return false;
  }
};

export const GET_PLANS_LIST = async () => {
  try {
    const response = await HTTPAidaBaseService.get(`/billing/plan-prices`);

    return response.data;
  } catch (error) {
    toast.error(error?.message);
    console.error(error.message);
    return false;
  }
};

export const GET_CUSTOMER_SUBSCRIPTION = async () => {
  try {
    const response = await HTTPAidaBaseService.post(
      `/billing/${getTenantFromToken()}/subscriptions/search`
    );

    return response.data;
  } catch (error) {
    toast.error(error?.message);
    console.error(error.message);
    return false;
  }
};

export const EXECUTE_PROMPT_GENERIC = async (prompt_code, promptParams) => {
  try {
    let payload = {
      params: promptParams,
    };
    const response = await HTTPAidaBaseService.post(
      `/${getTenantFromToken()}/submit/${prompt_code}`,
      payload
    );

    return response.data;
  } catch (error) {
    toast.error(error?.message);
    console.error(error.message);
    return false;
  }
};

export const CREATE_AUDIT_EVENT = async (props) => {
  const payload = auditPayload(
    props?.practitionerID,
    props?.patientName,
    props?.type,
    props?.reason
  );
  try {
    let res = await FHIRSave(POST, payload);
    if (res?.data) {
      return res;
    }
  } catch (e) {
    console.log(e);
  }
};

export const CREATE_BULK_PATIENTS = async (payload) => {
  try {
    const res = await HTTPAidaBaseServiceMultipartFormData?.post(
      `intake/tenant/${getTenantFromToken()}/patient-create-bulk`,
      payload
    );
    return res?.data;
  } catch (err) {
    console.error("Error uploading CSV:", err);
    throw err.response?.data || err.message || "Upload failed";
  }
};

export const CREATE_SINGLE_PATIENTS = async (payload) => {
  try {
    const res = await NokiService(
      POST,
      `intake/tenant/${getTenantFromToken()}/patient-create-single`,
      payload
    );

    return res?.data;
  } catch (err) {
    console.error("Error uploading CSV:", err);
    throw err.response?.data || err.message || "Upload failed";
  }
};

export const CREATE_SCHEDULE_COMPOSITION = async (payload) => {
  try {
    const res = await NokiEndpointService({
      endpoint: `/intake/tenants/${getTenantFromToken()}/schedule-plan`,
      action: "POST",
      payload,
    });

    return res?.data;
  } catch (err) {
    console.error("Error uploading CSV:", err);
    throw err.response?.data || err.message || "Upload failed";
  }
};

export const GET_RELATED_PERSON = async (relatedPersonId) => {
  try {
    const res = await FHIRSearch(`RelatedPerson/${relatedPersonId}`);
    return res?.data;
  } catch (err) {
    console.error("Error fetching related person:", err);
    throw err.response?.data || err.message || "Fetch failed";
  }
};

export const GET_COMPOSITIONS_BY_QUERY = async ({ queryParams = "" }) => {
  try {
    const res = await FHIRSearch(`Composition?${queryParams}`);
    return res;
  } catch (error) {
    console.error("Error fetching compositions by task IDs:", error);
    throw error;
  }
};

export const getAllComp = async ({ ids = "" }) => {
  try {
    const res = await FHIRSearch(`Composition`, `_id=${ids}`);
    return res;
  } catch (error) {
    console.error("Error fetching all compositions:", error);
    throw error;
  }
};

export const MOVE_TO_ONBOARDING = async (payload) => {
  const res = await OrieService(
    POST,
    `/assistants/tools/book_appointment`,
    {
      ...payload,
      "language": "en",
      "tenant_id": getTenantFromToken(),
    }
  );
  return res?.data;
};

export const GET_CALENDAR_HOLIDAYS_CONFIG = async ({ organisationId = "" }) => {
  if (!organisationId) return;
  try {
    const response = await FHIRSearch(
      `?resourceType=Basic&code=organization.preference.calendar&subject=Organization/${organisationId}`
    );

    if (response?.data?.total) {
      const rawResource = {
        ...response?.data?.entry?.[0]?.resource,
      };
      const configString = rawResource?.extension?.find(
        (item) => item?.url === "http://enliv.com/calendar/config"
      )?.valueString;

      if (configString) {
        const config = JSON.parse(configString);
        const list = getHolidayListFromConfig(config);
        return Array.isArray(list) ? list : [];
      } else {
        return [];
      }
    } else {
      return [];
    }
  } catch (e) {
    console.error("Failed to load calendar holidays", e);
    return [];
  }
};

export const GET_QUESTIONNAIRE = async (query = '') => {
  try {
    const response = await FHIRSearch(`Questionnaire${query}`);
    return response.data;
  } catch (e) {
    console.log(e)
  }
}

export const createResource = async payload => {
  try {
    const response = await FHIRSave(
      POST,
      payload
    );
    return response;
  } catch (error) {
    console.error(`Error creating ${payload?.resourceType}`, error);
  }
};

export const updateResource = async payload => {
  try {
    const response = await FHIRSave(PUT,
      payload
    );
    return response
  } catch (error) {
    console.error(`Error updating ${payload?.resourceType}`, error);
    return Promise.reject({
      code: 500,
      message: `Failed to update ${payload?.resourceType}`,
      error,
    });
  }
};
